// @ts-nocheck

import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.2em;
`;

const Cell = styled.div`
  flex: 1;
  margin: 1px 1px 1px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;

  font-weight: bold;
  transition: none 50ms ease-in-out;
  transition-property: background-color, color;

  color: ${theme.PresetsButton.color};
  cursor: pointer;
  min-height: 2em;

  ${({ $disabled, $highlight }) => {
    if ($disabled) {
      return css`
        background-color: ${theme.PresetsButton.backgroundColor};
        opacity: 0.5;
        pointer-events: none;
      `;
    }
    if ($highlight) {
      return css`
        background-color: ${theme.PresetsButton.activeBackgroundColor};
      `;
    }
    const activeStyle = Target.__MOBILE__
      ? css`
          &:hover {
            background-color: ${theme.PresetsButton.hoverBackgroundColor};
          }
        `
      : css`
          &:active {
            background-color: ${theme.PresetsButton.activeBackgroundColor};
          }
        `;

    return css`
      background-color: ${theme.PresetsButton.backgroundColor};
      ${activeStyle}
    `;
  }}
`;

type BasketPresetsProps = {
  className?: string;
  presets: Array<{ label: string; value: number; highlight: boolean }>;
  onPresetClick: (...params: unknown) => unknown;
  isDisabled: boolean;
};

const BasketPresets = ({ className, isDisabled, presets, onPresetClick }: BasketPresetsProps) => {
  const onClick = useCallback(
    (value) => () => {
      if (value !== null && !isDisabled) {
        onPresetClick(value);
      }
    },
    [onPresetClick, isDisabled],
  );

  if (!presets?.length) {
    return null;
  }

  return (
    <Row className={className}>
      {presets.map((preset, i) => (
        <Cell
          key={`preset-${i}`}
          onClick={onClick(preset.value)}
          $disabled={!preset.value}
          $highlight={preset.highlight}
        >
          {preset.label}
        </Cell>
      ))}
    </Row>
  );
};

export default React.memo<BasketPresetsProps>(BasketPresets);
